import { styled } from '@mui/material/styles';

export const SvgIcon = styled('svg')(() => ({
  display: 'inline-block',
  fill: 'currentColor',
  fontSize: '1.5em',
  height: '1em',
  transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  userSelect: 'none',
  verticalAlign: 'middle',
  width: '1em'
}));
